
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Productlist from './components/Productlist';
import Home from './components/Home';
import Productdetail from './components/Productdetail';
import About from './components/About';


function App() {
  return (
    <>
       {/* <Home/> */}
        {/* <Header/> */}
        <Routes>
          {/* <Route exact path="/"  ><Home/></Route> */}
          <Route exact path="/" element={<Home  />}></Route>
          <Route path="/product-list" element={<Productlist  />}></Route>
          <Route path="/product-detail/:id" element={<Productdetail  />}></Route>
          <Route path="/product-detail" element={<Productdetail  />}></Route>
          <Route path="/about" element={<About />}></Route>
        </Routes>
        {/* <Footer/> */}
    </>
    
  );
}

export default App;
